import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_el_checkbox = _resolveComponent("el-checkbox");
  return _openBlock(), _createBlock(_component_el_checkbox, {
    "true-label": $props.field.true_label,
    "false-label": $props.field.false_label,
    modelValue: $data.model,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = function ($event) {
      return $data.model = $event;
    })
  }, {
    "default": _withCtx(function () {
      return [_createTextVNode(_toDisplayString($props.field.checkbox_label), 1 /* TEXT */)];
    }),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["true-label", "false-label", "modelValue"]);
}